import { UsersAvatarComponent } from './avatar/avatar.component';

export const USERS_DECLARATIONS: any[] = [
    UsersAvatarComponent
];
